import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Divider,
  Form,
  Image,
  Radio,
  Row,
  Select,
  Slider,
  Space,
  Spin,
} from 'antd';
import './Filter.scss';
import { useCallback, useEffect, useMemo, useState } from 'react';
import Api from '../../network/ApiConfig';
import {
  generateYearsArray,
  handelGetParamsFromUrl,
} from '../../helpers/helpers';
import { useHistory } from 'react-router-dom';

export default function Filters({ className, location, ...props }) {
  const [form] = Form.useForm();
  const [filterLoading, setFilterLoading] = useState(false);
  const [filtersData, setFilterData] = useState({});
  const history = useHistory();
  const query = new URLSearchParams(location.search);
  const handleFilterRequest = useCallback(() => {
    const body = handelGetParamsFromUrl(query, location);
    setFilterLoading(true);
    Api.post('/CarModels/FilterRequest', body).then(
      (res) => {
        setFilterLoading(false);
        if (res?.status === 200) {
          setFilterData(res?.data?.model || []);
        }
      },
      (err) => {
        setFilterLoading(false);
      }
    );
  }, [location, query]);

  const yearsOption = useMemo(() => {
    return generateYearsArray(
      filtersData?.ProductionYearFrom,
      filtersData?.ProductionYearTo,
      true
    );
  }, [filtersData?.ProductionYearFrom, filtersData?.ProductionYearTo]);

  useEffect(() => {
    handleFilterRequest();
  }, [location.search]);

  return (
    <Spin spinning={filterLoading}>
      <Form
        form={form}
        className='filter-holder'
        layout='vertical'
        onFinish={(values) => {
          if (!values) return;
          const parsedValues = { ...values };
          delete parsedValues['prices'];
          for (let key in parsedValues) {
            if (parsedValues[key] === undefined) {
              delete parsedValues[key];
            }
          }
          if (values?.prices) {
            parsedValues['FromPrice'] = values?.prices[0];
            parsedValues['ToPrice'] = values?.prices[1];
          }
          const searchParams = new URLSearchParams(parsedValues).toString();
          history.push({
            path: '/cars',
            search: searchParams,
            state: { fromFilters: true },
          });
        }}
      >
        <p className='filter--title'>التصفية</p>

        <Form.Item className='input-holder' name='CarModelId'>
          <Select
            placeholder='نموذج السيارة (فورتونر)'
            options={filtersData?.CarModels}
            fieldNames={{
              label: 'NameLT',
              value: 'Id',
            }}
          ></Select>
        </Form.Item>
        <div className='price-slider-wrapper'>
          <Form.Item label='نطاق السعر' name='prices' className='price-range'>
            <Slider
              style={{ width: '100%' }}
              min={filtersData?.FromPrice}
              max={filtersData?.ToPrice}
              range={{ draggableTrack: true }}
              defaultValue={[filtersData?.FromPrice, 2000]}
            />
          </Form.Item>
          <div className='price-labels'>
            <p>الحد الأدنى ${filtersData?.FromPrice}</p>
            <p>الحد الأقصى ${filtersData?.ToPrice}</p>
          </div>
        </div>
        <Form.Item className='input-holder' name='GearTypeId'>
          <Select
            placeholder='نوع الجير'
            options={filtersData?.GearTypes?.filter((item) => item)}
            fieldNames={{
              label: 'NameLT',
              value: 'Id',
            }}
          ></Select>
        </Form.Item>
        <Form.Item className='input-holder' name='CarFuelTypeId'>
          <Select
            placeholder='نوع الوقود'
            options={filtersData?.CarFuelTypes?.filter((item) => item)}
            fieldNames={{
              label: 'NameLT',
              value: 'Id',
            }}
          ></Select>
        </Form.Item>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item
              placeholder='السنة'
              className='input-holder'
              name={'ProductionYearFrom'}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (getFieldValue('ProductionYearTo') < value) {
                      return Promise.reject(
                        new Error('Production year from must be less than to')
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Select placeholder='من' options={yearsOption}></Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className='input-holder'
              name='ProductionYearTo'
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (getFieldValue('ProductionYearFrom') > value) {
                      return Promise.reject(
                        new Error('Production year from must be more than to')
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <Select placeholder='الي' options={yearsOption}></Select>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          className='car-shaps-wrapper'
          placeholder='نوع الهيكل'
          name='CarShapeId'
        >
          <Radio.Group
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(1,1fr)',
              gap: '12px',
            }}
          >
            {filtersData?.CarShapes?.map((item) => (
              <Radio key={item?.Id} value={item?.Id}>
                {/* {item?.NameLT} */}
                <Image
                  style={{ objectFit: 'contain' }}
                  height={40}
                  width={90}
                  src={item?.Image}
                  preview={false}
                />
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
        <div className='form-btns-wrapper'>
          <Button
            ghost
            className='form-btn'
            type='primary'
            onClick={() => {
              form.resetFields();
              history.push({ path: '/cars', search: '' });
            }}
          >
            مسح التصفية
          </Button>
          <Button className='form-btn' type='primary' htmlType='submit'>
            تصفية
          </Button>
        </div>
      </Form>
    </Spin>
  );
}
